import type { AnalyticsService } from './AnalyticsService';
import type { AuthService } from './AuthService.svelte';
import type { CookieConsentService } from './CookieConsentService';
import type { FirebaseServiceReduced } from './FirebaseService';
import type { NotificationService } from './NotificationService';
import type { PosthogService } from './PosthogService';
import type { UserService } from './UserService.svelte';

export type ServiceContext = {
	firebaseService: FirebaseServiceReduced;
	authService: AuthService;
	posthogService: PosthogService;
	analyticsService: AnalyticsService;
	userService: UserService;
	cookieConsentService: CookieConsentService;
	notificationService: NotificationService;
};

export function setServiceContext(value: ServiceContext) {
	serviceContext = value;
}

export let serviceContext: ServiceContext;
